<template>
<b-card body-class="p-3" class="lifestyle-form">
    <validation-observer ref="observer" v-slot="{ passes }">
    <b-form @submit.prevent="passes(onFormSubmit)" novalidate>

        <validation-provider vid="non_field_errors" v-slot="{ errors }">
            <b-form-invalid-feedback :state="errors[0] ? false : null">
                <h6 class="d-block p-2 mb-2 bg-danger text-white small">{{ errors[0] }}</h6>
            </b-form-invalid-feedback>
        </validation-provider>

        <b-row>
            <b-col md="6">
                <h6 class="text-muted small text-uppercase mb-2">Voeding (afgelopen week)</h6>
                <b-form-group label-size="sm" label-cols-sm="5" label="Vers fruit"><b-form-select size="sm" plain v-model="form.fruit_frequency" :options="frequencyOptions" /></b-form-group>
                <b-form-group label-size="sm" label-cols-sm="5" label="Groente"><b-form-select size="sm" plain v-model="form.vegetable_frequency" :options="frequencyOptions" /></b-form-group>
                <b-form-group label-size="sm" label-cols-sm="5" label="Zoutige snack"><b-form-select size="sm" plain v-model="form.salty_snack_frequency" :options="frequencyOptions" /></b-form-group>
                <b-form-group label-size="sm" label-cols-sm="5" label="Gebakken voeding"><b-form-select size="sm" plain v-model="form.fried_food_frequency" :options="frequencyOptions" /></b-form-group>
                <b-form-group label-size="sm" label-cols-sm="5" label="Suikerhoudende dranken"><b-form-select size="sm" plain v-model="form.sugary_drink_frequency" :options="frequencyOptions" /></b-form-group>
                <b-form-group label-size="sm" label-cols-sm="5" label="Geconserveerde voeding"><b-form-select size="sm" plain v-model="form.preserved_food_frequency" :options="frequencyOptions" /></b-form-group>
                <validation-provider name="Water" vid="water_liters_per_day" v-slot="{ errors }">
                    <b-form-group label-size="sm" label-cols-sm="5" label="Water (L/dag)" :invalid-feedback="errors[0]" :state="errors[0] ? false : null">
                        <b-input-group size="sm" append="L"><b-form-input type="number" step="0.5" min="0" v-comma2dot v-model="form.water_liters_per_day" /></b-input-group>
                    </b-form-group>
                </validation-provider>

                <h6 class="text-muted small text-uppercase mt-3 mb-2">Beweging</h6>
                <validation-provider name="Exercise minutes" vid="exercise_minutes_per_week" v-slot="{ errors }">
                    <b-form-group label-size="sm" label-cols-sm="5" label="Inspanning" :invalid-feedback="errors[0]" :state="errors[0] ? false : null">
                        <b-input-group size="sm" append="min/wk"><b-form-input type="number" min="0" v-model="form.exercise_minutes_per_week" /></b-input-group>
                    </b-form-group>
                </validation-provider>
                <b-form-group label-size="sm" label-cols-sm="5" label="Intensiteit"><b-form-select size="sm" plain v-model="form.exercise_intensity" :options="intensityOptions" /></b-form-group>
            </b-col>

            <b-col md="6">
                <h6 class="text-muted small text-uppercase mb-2">Roken</h6>
                <b-form-group label-size="sm" label-cols-sm="5" label="Status"><b-form-select size="sm" plain v-model="form.smoking_status" :options="smokingStatusOptions" /></b-form-group>
                <b-form-group v-if="form.smoking_status === 'current' || form.smoking_status === 'former'" label-size="sm" label-cols-sm="5" label="Sigaretten/dag"><b-form-input size="sm" type="number" min="0" v-model="form.cigarettes_per_day" /></b-form-group>
                <b-form-group v-if="form.smoking_status === 'former'" label-size="sm" label-cols-sm="5" label="Quit date"><b-form-datepicker size="sm" v-model="form.smoking_quit_date" :locale="currentLang" :max="maxDate" placeholder="YYYY-MM-DD" /></b-form-group>
                <b-form-group v-if="form.smoking_status === 'former'" label-size="sm" label-cols-sm="5" label="Years smoked"><b-form-input size="sm" type="number" step="0.5" min="0" v-comma2dot v-model="form.smoking_duration_years" /></b-form-group>

                <h6 class="text-muted small text-uppercase mt-3 mb-2">Alcohol</h6>
                <b-form-group label-size="sm" label-cols-sm="5" label="Frequency"><b-form-select size="sm" plain v-model="form.alcohol_frequency" :options="alcoholFrequencyOptions" /></b-form-group>
                <b-form-group v-if="alcoholActive" label-size="sm" label-cols-sm="5" label="Type"><b-form-select size="sm" plain v-model="form.alcohol_type" :options="alcoholTypeOptions" /></b-form-group>
                <b-form-group v-if="alcoholActive" label-size="sm" label-cols-sm="5" label="Drinks/occasion"><b-form-select size="sm" plain v-model="form.drinks_per_occasion" :options="drinksPerOccasionOptions" /></b-form-group>
                <b-form-group v-if="alcoholActive" label-size="sm" label-cols-sm="5" label="Times/week"><b-form-input size="sm" type="number" min="0" v-model="form.alcohol_uses_per_week" /></b-form-group>
                <b-form-group v-if="form.alcohol_frequency === 'former'" label-size="sm" label-cols-sm="5" label="Quit year"><b-form-input size="sm" type="number" min="1900" :max="thisYear" v-model="form.alcohol_quit_year" /></b-form-group>

                <b-form-group label-size="sm" label-cols-sm="5" label="Notes" class="mt-3"><b-form-textarea size="sm" v-model="form.notes" rows="6" max-rows="12" no-resize /></b-form-group>
                <b-form-group label-size="sm" label-cols-sm="5" label="Date"><b-form-datepicker size="sm" placeholder="-- date --" v-model="form.administrative_datetime" :locale="currentLang" :max="maxDate" /></b-form-group>
            </b-col>
        </b-row>

        <hr class="my-2" />
        <h6 class="text-muted small text-uppercase mb-2">Sport activiteiten</h6>
        <div v-for="(activity, index) in form.sport_activities" :key="index" class="mb-1">
            <b-form-row>
                <b-col md="4"><b-form-select size="sm" plain v-model="activity.sport_type" :options="sportTypeOptions" /></b-col>
                <b-col md="3"><b-form-select size="sm" plain v-model="activity.frequency" :options="frequencyPerWeekOptions" /></b-col>
                <b-col md="2"><b-form-select size="sm" plain v-model="activity.duration_per_session" :options="durationOptions" /></b-col>
                <b-col md="2"><b-form-select size="sm" plain v-model="activity.intensity" :options="intensityOptions" /></b-col>
                <b-col md="1"><b-button type="button" block size="sm" variant="outline-danger" @click="removeSport(index)"><i class="fa-light fa-xmark"></i></b-button></b-col>
            </b-form-row>
        </div>
        <b-button type="button" size="sm" variant="outline-primary" class="mb-2" @click="addSport"><i class="fa-solid fa-plus"></i> activity</b-button>

        <div class="mt-2">
            <b-button size="sm" class="mr-1" type="submit" variant="success"><i class="fa-regular fa-circle-dot"></i> Submit</b-button>
            <b-button size="sm" v-if="isDirty || hasErrors" type="button" variant="danger" @click="reset"><i class="fa-solid fa-ban"></i> Reset</b-button>
        </div>

    </b-form>
    </validation-observer>
</b-card>
</template>
<style scoped>
.lifestyle-form .form-group { margin-bottom: 0.4rem; }
.lifestyle-form h6 { font-size: 0.75rem; letter-spacing: 0.04em; }
.lifestyle-form .col-form-label { padding-top: calc(0.25rem + 1px); padding-bottom: calc(0.25rem + 1px); font-size: 0.8rem; }
</style>
<script>
import FormExtension from "@/core/components/FormExtension"
import { mapGetters, mapState, mapActions } from "vuex"

const FREQUENCY_OPTIONS = [
    { value: null, text: '-- select --' },
    { value: '4-5x/day', text: '4-5x per dag' },
    { value: '2-3x/day', text: '2-3x per dag' },
    { value: '1x/day', text: '1x per dag' },
    { value: '5-6x/week', text: '5-6x per week' },
    { value: '2-4x/week', text: '2-4x per week' },
    { value: '1-2x/week', text: '1-2x per week' },
    { value: 'none', text: 'Geen' },
]

const INTENSITY_OPTIONS = [
    { value: null, text: '-- select --' },
    { value: 'light', text: 'Licht' },
    { value: 'moderate', text: 'Matig' },
    { value: 'heavy', text: 'Zwaar' },
]

const SMOKING_STATUS_OPTIONS = [
    { value: null, text: '-- select --' },
    { value: 'current', text: 'Current Smoker' },
    { value: 'former', text: 'Former Smoker' },
    { value: 'never', text: 'Never Smoked' },
    { value: 'passive', text: 'Passive Smoker' },
]

const ALCOHOL_FREQUENCY_OPTIONS = [
    { value: null, text: '-- select --' },
    { value: 'never', text: 'Never' },
    { value: 'yearly', text: 'Yearly' },
    { value: 'quarterly', text: 'Quarterly' },
    { value: 'monthly', text: 'Monthly' },
    { value: 'weekly', text: 'Weekly' },
    { value: 'daily', text: 'Daily' },
    { value: 'former', text: 'Former' },
]

const ALCOHOL_TYPE_OPTIONS = [
    { value: null, text: '-- select --' },
    { value: 'beer', text: 'Beer' },
    { value: 'wine', text: 'Wine' },
    { value: 'liquor', text: 'Liquor' },
    { value: 'mix', text: 'Mix' },
    { value: 'other', text: 'Other' },
]

const DRINKS_PER_OCCASION_OPTIONS = [
    { value: null, text: '-- select --' },
    { value: '1-4', text: '1-4' },
    { value: '5-8', text: '5-8' },
    { value: '9-14', text: '9-14' },
    { value: '14+', text: '14+' },
]

const SPORT_TYPE_OPTIONS = [
    { value: null, text: '-- type --' },
    { value: 'cardio', text: 'Duur- en cardiotraining' },
    { value: 'strength', text: 'Krachttraining' },
    { value: 'flexibility', text: 'Lichaamsbewustzijn en flexibiliteit' },
    { value: 'ball', text: 'Balsporten' },
    { value: 'martial', text: 'Verdedigings- en vechtsporten' },
    { value: 'outdoor', text: 'Recreatieve en buitensporten' },
    { value: 'dance', text: 'Dans en ritme' },
    { value: 'other', text: 'Overige sporten en activiteiten' },
    { value: 'kids', text: 'Kinderspel / Jeugdactiviteiten' },
]

const FREQUENCY_PER_WEEK_OPTIONS = [
    { value: null, text: '-- frequency --' },
    { value: '0', text: 'Nooit' },
    { value: '1', text: '1x per week' },
    { value: '2', text: '2x per week' },
    { value: '3', text: '3x per week' },
    { value: '4', text: '4x per week' },
    { value: '5', text: '5x per week' },
    { value: '6', text: '6x per week' },
    { value: '7', text: 'Dagelijks' },
    { value: '>7', text: 'Meerdere keren per dag' },
    { value: 'variable', text: 'Geen vast patroon' },
]

const DURATION_OPTIONS = [
    { value: null, text: '-- duration --' },
    { value: '<15', text: '< 15 min' },
    { value: '15-30', text: '15-30 min' },
    { value: '31-45', text: '31-45 min' },
    { value: '46-60', text: '46-60 min' },
    { value: '>60', text: '> 60 min' },
]

export default FormExtension.extend({
    name: "lifestyle-form",
    data() {
        return {
            form: null,
            maxDate: new Date(),
            frequencyOptions: FREQUENCY_OPTIONS,
            intensityOptions: INTENSITY_OPTIONS,
            smokingStatusOptions: SMOKING_STATUS_OPTIONS,
            alcoholFrequencyOptions: ALCOHOL_FREQUENCY_OPTIONS,
            alcoholTypeOptions: ALCOHOL_TYPE_OPTIONS,
            drinksPerOccasionOptions: DRINKS_PER_OCCASION_OPTIONS,
            sportTypeOptions: SPORT_TYPE_OPTIONS,
            frequencyPerWeekOptions: FREQUENCY_PER_WEEK_OPTIONS,
            durationOptions: DURATION_OPTIONS,
        }
    },
    computed: {
        thisYear() {
            return new Date().getFullYear()
        },
        alcoholActive() {
            return this.form?.alcohol_frequency && !['never', 'former'].includes(this.form.alcohol_frequency)
        }
    },
    watch: {
        form: {
            deep: true,
            handler(val) {
                if (!val) return
                this.isDirty = this.form.dirty()
                if (this.isDirty) {
                    this.dirty()
                } else {
                    this.validated()
                }
            }
        },
        refresh: {
            immediate: true,
            handler(val) {
                if (val) this.reset()
            }
        }
    },
    methods: {
        addSport() {
            this.form.sport_activities.push({
                sport_type: null,
                frequency: null,
                duration_per_session: null,
                intensity: null,
                consistency_token: null
            })
        },
        removeSport(index) {
            this.form.sport_activities.splice(index, 1)
        },
        cleanValue(v) {
            if (v === "" || v === undefined) return null
            return v
        },
        cleanPayload(payload) {
            const cleaned = {}
            Object.keys(payload).forEach(k => {
                cleaned[k] = this.cleanValue(payload[k])
            })
            return cleaned
        },
        onFormSubmit() {
            const payload = this.cleanPayload(this.form.data())
            payload.interventions = payload.interventions || []
            payload.sport_activities = (this.form.sport_activities || [])
                .filter(a => a.sport_type)
                .map(a => this.cleanPayload(a))

            this.callback(payload).then(() => {
                this.reset()
                this.notify("Patient lifestyle created", "Patient lifestyle was created successfully")
                this.$emit('created')
            })
            .catch(errors => {
                this.hasErrors = true
                if (errors.response?.data) {
                    this.$refs.observer?.setErrors(errors.response.data)
                    const detail = errors.response.data.detail
                        || errors.response.data.non_field_errors?.[0]
                        || `Check the highlighted fields (status ${errors.response.status})`
                    this.notify("Could not save lifestyle", detail, 'danger')
                } else {
                    this.notify("Could not save lifestyle", errors.message || "Unknown error", 'danger')
                }
            })
        },
        newForm() {
            this.form = Form.create({
                fruit_frequency: null,
                vegetable_frequency: null,
                salty_snack_frequency: null,
                fried_food_frequency: null,
                sugary_drink_frequency: null,
                preserved_food_frequency: null,
                water_liters_per_day: null,
                exercise_minutes_per_week: null,
                exercise_intensity: null,
                smoking_status: null,
                cigarettes_per_day: null,
                smoking_quit_date: null,
                smoking_duration_years: null,
                alcohol_frequency: null,
                alcohol_type: null,
                drinks_per_occasion: null,
                alcohol_uses_per_week: null,
                alcohol_quit_year: null,
                interventions: [],
                notes: "",
                administrative_datetime: null,
                sport_activities: [],
                consistency_token: null
            })
        },
        reset() {
            this.newForm()
            this.$nextTick(() => {
                this.$refs.observer?.reset()
                this.hasErrors = false
                this.validated()
            })
        }
    },
    created() {
        this.newForm()
    }
})
</script>
